<template>
  <div>
    <div class="columns">
      <div class="column is-6">
        <select-input
          required
          :items="assessors"
          :value="assessor.assessor_id"
          @input="updateAssessorType"
          label-key="name"
          value-key="id">Assesor</select-input>
      </div>
      <div class="column is-3">
        
      </div>
    </div>

    <div v-if="activeAssesor">

      <p>{{ activeAssesor.description }}</p>

      <p v-if="!activeAssesor.standard_fed" class="has-text-danger">This assessor does not rely on any input from standards.</p>

      <div v-else>
        <span class="has-text-danger">This Assessor will receive it's assessment value from the given standards it is assigned to. Please enter the required values below.</span>
      </div>
      <hr>
      <div v-for="section in assessor.standards" :key="section.id">
        <standard-value :assessor-type="activeAssesor" :section="section" :cast-type="attribute.cast_type"/>
      </div>
      
    </div>

  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import { find } from 'lodash'
import StandardValue from './StandardValue.vue'
import { get } from '@/api/request'

export default {

  components: {
    StandardValue
  },

  props: {
    attribute: {
      type: Object,
      default: () => ({})
    }
  },

  created() {
    this.$store.commit('assessor/setStandards', this.checkpoint.sections)
  },

  data: () => ({
    assessors: []
  }),

  beforeCreate() {
    get('api/super/assessment-handlers', ({data}) => this.assessors = data)
  },

  methods: {
    ...mapMutations('assessor', [
      'updateAssessor',
      'clearAssessorSecureSettings'
    ]),
    updateAssessorType(value) {
      this.updateAssessor(value)
      if(!this.activeAssesor.standard_fed) this.clearAssessorSecureSettings()
    }
  },

  computed: {
    ...mapGetters('assessor', [
      'assessor'
    ]),
    ...mapGetters('checkpoint', [
      'checkpoint'
    ]),
    activeAssesor() {
      return find(this.assessors, assessor => assessor.id === this.assessor.assessor_id) 
    }
  }
}
</script>